import React, { useState } from 'react';
import ExoForm from '../../../components/exo/ExoForm';
import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../../api/api';
import ExoAlert from '../../../components/exo/ExoAlert';

export const NetworkStorageForm = ({
  startDataCollection,
  onCreate,
  onClose,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [alert, setAlert] = useState(null);

  const connectionTest = {
    label: t('Test Connection'),
    type: 'checkConnection',
  };

  const initialFields = [
    {
      label: t('Driver'),
      key: 'driver',
      type: 'customSelect',
      default: 'smb',
      noUnselect: true,
      options: [
        { label: 'SMB', value: 'smb' },
        { label: 'FTP', value: 'ftp' },
        { label: 'SFTP', value: 'sftp' },
        { label: 'Dropbox', value: 'dropbox' },
      ],
    },
    {
      label: t('Name'),
      key: 'name',
      type: 'text',
    },
    {
      label: t('Root Directory'),
      key: 'rootDirectory',
      type: 'text',
    },
    {
      label: t('Project Directory'),
      key: 'projectRootDirectory',
      type: 'text',
    },
  ];

  const smbFtpFields = [
    {
      label: t('Host'),
      key: 'host',
      type: 'text',
    },
    {
      label: t('Username'),
      key: 'username',
      type: 'text',
    },
    {
      label: t('Password'),
      key: 'password',
      type: 'password',
    },
  ];

  const sshFields = [
    {
      label: t('SSH Private Key'),
      key: 'sshPrivateKey',
      type: 'text',
      multiline: true,
    },
    { label: t('SSH Key Password'), key: 'sshKeyPassword', type: 'text' },
  ];

  const fieldMap = {
    smb: [...initialFields, ...smbFtpFields, connectionTest],
    ftp: [...initialFields, ...smbFtpFields, connectionTest],
    sftp: [...initialFields, ...smbFtpFields, ...sshFields, connectionTest],
    dropbox: [...initialFields],
  };

  const [fields, setFields] = useState(fieldMap['smb']);
  const [selected, setSelected] = useState('smb');

  function handleCheckConnection(data) {
    if (data.driver === 'dropbox') {
      const newData = { ...data, redirectUrl: window.location.href };
      DBRequest({
        config,
        path: data.id ? `dropbox/update/${data.id}` : 'dropbox/create',
        method: data.id ? API_PATCH(newData) : API_POST(newData),
        onResponse: handleDropboxResponse,
      });
    } else {
      DBRequest({
        config,
        path: `network-storages/test-connection`,
        method: API_POST(data),
        onResponse: () => handleCreateDisk(data),
        onError: () =>
          setAlert({
            message: t('Connection Failed'),
            cancelLabel: t('Schließen'),
          }),
      });
    }
  }

  function handleDropboxResponse(res) {
    window.location.assign(res.data.authUrl);
    onCreate(res.data?.networkStorage);
    onClose();
  }

  function handleResponse(data) {
    onCreate(data.data);
    onClose();
  }

  function handleCreateDisk(data) {
    const isUpdate = Boolean(startDataCollection && startDataCollection.id);
    DBRequest({
      config,
      path: isUpdate
        ? `network-storages/${startDataCollection.id}`
        : `network-storages`,
      method: isUpdate ? API_PATCH(data) : API_POST(data),
      onResponse: handleResponse,
    });
  }

  function handleChange(data) {
    if (data?.driver) {
      setFields(fieldMap[data.driver]);
      setSelected(data.driver);
    }
  }

  return (
    <>
      <ExoForm
        noEnter={true}
        header={t('Network Storage')}
        fields={fields}
        onSubmit={handleCheckConnection}
        onCancel={onClose}
        noDifferences
        startDataCollection={startDataCollection}
        onChange={handleChange}
        submitText={selected === 'dropbox' ? t('To dropbox') : null}
      />
      <ExoAlert
        alert={alert || {}}
        open={Boolean(alert)}
        onClose={() => setAlert(null)}
      />
    </>
  );
};
